/**
 * Transform URL object keeping curly brackets `{}`
 */
export const hrefFromURL = (url) => url.href.replaceAll('%7B', '{').replaceAll('%7D', '}');
//# sourceMappingURL=hrefFromURL.js.map